export default __webpack_public_path__ + "static/cause-cf135e5d09163150b2644433af6a9765.svg";